<template>
  <div class="tags-container">
    <el-tag
      class="address-tag-wrapper"
      v-for="address in addressList"
      :key="address.id"
    >
      <address-tag :address="address" trigger="click" />
    </el-tag>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'

import { queryAddress } from '@/api/address'
import AddressTag from '../address/AddressTag.vue'
export default {
  name: 'ShipmentAddressTags',
  components: { AddressTag },
  props: {
    addressQuery: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      debouncedQuery: debounce(this.fetchAddress, 300),
      addressList: []
    }
  },
  watch: {
    addressQuery: {
      handler(one, two) {
        if (isEqual(one, two)) return
        this.debouncedQuery()
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    fetchQuery() {
      return {
        ...this.addressQuery,
        size: -1
      }
    }
  },
  methods: {
    async fetchAddress() {
      this.loadingData = true
      let page
      if (!isEmpty(this.addressQuery)) {
        page = await queryAddress(this.fetchQuery)
      }
      const records = page?.records ?? []
      this.$set(this, 'addressList', records)
      this.loadingData = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.tags-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
  padding: 0 $home-card-padding-x;
}

.address-tag-wrapper {
  display: flex;
  font-size: 18px;
  padding: 20px 10px;

  &:hover {
    cursor: pointer;
  }

  span {
    padding: 10px 0;
  }

  @extend .light-oswald, .f-c-c-c;
}
</style>
